/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-var-requires */
import * as moment from 'moment';
import { TC_BILLING_ACC_ID,
    TC_BILLING_ISLEGACY,
    TC_BILLING_SELECTEDCIDN,
    TC_BILLING_INVOICE_LIST_FILTER} from '../shared-framework/utils/constants/session-constants';

// 5 min after Elapsed Time
export const FIVE_MINUTE_ELAPSED_TIME = 300000;
export const getCidn = () => {
    let CIDN = sessionStorage.getItem(TC_BILLING_SELECTEDCIDN) ? JSON.parse(sessionStorage.getItem(TC_BILLING_SELECTEDCIDN)) : '';
    if (typeof (CIDN) === 'object') {
        CIDN = CIDN.value ? CIDN.value : '';
    }
    return CIDN;
}
export const getCompanyName = () => {
    let CIDN = sessionStorage.getItem(TC_BILLING_SELECTEDCIDN) ? JSON.parse(sessionStorage.getItem(TC_BILLING_SELECTEDCIDN)) : '';
    if (typeof (CIDN) === 'object') {
        CIDN = CIDN?.name ? CIDN?.name : '';
    }
    return CIDN;
}

export const getCidnObject = () => {
    const cidnInfo = sessionStorage.getItem(TC_BILLING_SELECTEDCIDN)
        ? JSON.parse(sessionStorage.getItem(TC_BILLING_SELECTEDCIDN))
        : ''

    if (typeof cidnInfo !== 'object') {
        throw new Error('cidnInfo is not an object')
    }
    return {name: cidnInfo?.name, value: cidnInfo?.value}
}

export const setCidnObject = (defaultCidnObj) => {
    sessionStorage.setItem(TC_BILLING_SELECTEDCIDN,
        JSON.stringify(defaultCidnObj));
}

export const getSelectedAccountId = () => {
    let accountID = sessionStorage.getItem(TC_BILLING_ACC_ID) ? JSON.parse(sessionStorage.getItem(TC_BILLING_ACC_ID)) : '';
    if (typeof (accountID) === 'object') {
        accountID = accountID?.value || '';
    }
    return accountID;
}

export const getSelectedAccountObject = () => {
    const accountInfo = sessionStorage.getItem(TC_BILLING_ACC_ID) ? JSON.parse(sessionStorage.getItem(TC_BILLING_ACC_ID)) : '';

    if (typeof (accountInfo) !== 'object') {
        throw new Error('accountInfo is not an object')
    }

    return { name: accountInfo?.name, value: accountInfo?.value}
}

export const isCardExpired = (expiryMonth, expiryYear) => {
    const currentMonth = moment().month() + 1;
    const currentYear = moment().year();

    return (parseInt(expiryYear, 10) < currentYear ||
        (parseInt(expiryYear, 10) === currentYear && parseInt(expiryMonth, 10) < currentMonth))
}

export const getCorrectCardDetail = (cardType: string) => {
    let icon = '';
    let title = '';
    switch (cardType?.toLowerCase()) {
        case 'bank':
            icon = 'icon-network-bank-transfer';
            title = 'Bank account';
            break;
        case 'bank_account':
            icon = 'icon-network-bank-transfer';
            title = 'Bank account';
            break;
        case 'master_card':
            icon = 'icon-network-mastercard';
            title = 'Mastercard';
            break;
        case 'visa':
            icon = 'icon-network-visa';
            title = 'Visa';
            break;
        case 'amex':
            icon = 'icon-bills-amex';
            title = 'American Express';
            break;
        default:
            icon = 'icon-network-bank-transfer';
            title = 'Bank account';
            break;
    }
    return { icon, title };
}
export const getUserPermissionDetails = (getDetails) => {
    const getBillingDetails = getDetails?.filter((list) => list.name === 'billing');
    const userType = getBillingDetails?.flatMap((p) =>
        p.permissions?.flatMap((spg) =>
            spg.subPermissionsGroup?.flatMap((sp) => sp.subPermissions?.map((permissionsGroup) => permissionsGroup))));
    return (userType?.some((group) => group?.name === 't-analyst-user-administrator' || group?.name === 't-analyst-general-user' ? true : false));
}

export const getCardPathAble = (cardType: string) => {
    let icon = '';
    let iconName = '';
    switch (cardType?.toLowerCase()) {
        case 'master_card':
            icon = require('../images/payment-type-mastercard.svg');
            iconName = 'Mastercard';
            break;
        case 'visa':
            icon = require('../images/payment-type-visa.svg');
            iconName = 'Visa';
            break;
        case 'amex':
            icon = require('../images/payment-type-amex.svg');
            iconName = 'American Express';
            break;
        default:
            icon = '';
            iconName = '';
    }
    return { icon, iconName };
}

export const getHasLegacy = () => {
    return sessionStorage.getItem(TC_BILLING_ISLEGACY) &&
		sessionStorage.getItem(TC_BILLING_ISLEGACY) !== 'undefined' ?
        JSON.parse(sessionStorage.getItem(TC_BILLING_ISLEGACY)) : false ;
}
export const getUserType = () => {
    const hasLegacy = getHasLegacy();
    const typeOfUser = hasLegacy ? 'Legacy User ' : 'Strategic User ';
    return typeOfUser
}

export const sanitizeQueryParam = (param) => {
    return encodeURIComponent(param?.replace(/<[^>]+>/g, '') // Remove HTML tags
        .replace(/[\'\"]/g, '\\$&')); // Escape single and double quotes
}

export const updateInvoiceListFilter = (filterValue) => {
    sessionStorage.setItem(TC_BILLING_INVOICE_LIST_FILTER, JSON.stringify(filterValue));
}

export const getInvoiceListFilter = () => {
    const filters = sessionStorage.getItem(TC_BILLING_INVOICE_LIST_FILTER) ?
        JSON.parse(sessionStorage.getItem(TC_BILLING_INVOICE_LIST_FILTER)) : null
    return filters;
}
